import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-236d467a")

_pushScopeId("data-v-236d467a")
const _hoisted_1 = { class: "late-early-application-container text-gray-333" }
const _hoisted_2 = { class: "mb-8 font-bold font-size-24" }
const _hoisted_3 = { class: "mb-8" }
const _hoisted_4 = { class: "font-size-18 font-bold mb-1" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_6 = { class: "mb-8" }
const _hoisted_7 = { class: "font-size-18 font-bold mb-1" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "flex items-center late-early--detail" }
const _hoisted_14 = { class: "mr-6" }
const _hoisted_15 = { class: "mr-8" }
const _hoisted_16 = { class: "mr-6" }
const _hoisted_17 = { class: "mr-8" }
const _hoisted_18 = { class: "mb-8" }
const _hoisted_19 = { class: "font-size-18 font-bold mb-1" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_21 = {
  key: 1,
  class: "truncate-5-line"
}
const _hoisted_22 = { class: "text-light-blue truncate font-bold underline" }
const _hoisted_23 = {
  key: 1,
  class: "text-light-blue truncate font-bold underline"
}
const _hoisted_24 = {
  key: 0,
  class: "text-center flex justify-center"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BackPreviousPage = _resolveComponent("BackPreviousPage")
  const _component_Table = _resolveComponent("Table")
  const _component_Button = _resolveComponent("Button")
  const _component_Input = _resolveComponent("Input")
  const _component_InputFile = _resolveComponent("InputFile")
  const _component_ReasonUpdateStatusApplication = _resolveComponent("ReasonUpdateStatusApplication")
  const _component_ApplicationApproveFlowDetail = _resolveComponent("ApplicationApproveFlowDetail")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_BackPreviousPage, { onClick: _ctx.goToBack }, null, 8, ["onClick"]),
      _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('lateEarlyApplication')), 1),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.t('targetDate')), 1),
        _hoisted_5,
        _createVNode("div", null, _toDisplayString(_ctx.displayTargetDate(_ctx.targetDate)), 1)
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, _toDisplayString(_ctx.t('leaveTime')), 1),
        _hoisted_8,
        _createVNode(_component_Table, {
          class: "overflow-auto text-center mb-2",
          headers: _ctx.lateEarlyHeaders,
          data: _ctx.checkTimeApplication
        }, {
          type: _withId(({ index }) => [
            _createTextVNode(_toDisplayString(_ctx.lateEarlyApplicationData[index].type), 1)
          ]),
          checkin_time: _withId(({ item, index }) => [
            (index === 0)
              ? (_openBlock(), _createBlock("div", _hoisted_9, _toDisplayString(item.work_schedule_start_time), 1))
              : (_openBlock(), _createBlock("div", _hoisted_10, _toDisplayString(item.checkin_time), 1))
          ]),
          checkout_time: _withId(({ item, index }) => [
            (index === 0)
              ? (_openBlock(), _createBlock("div", _hoisted_11, _toDisplayString(item.work_schedule_end_time), 1))
              : (_openBlock(), _createBlock("div", _hoisted_12, _toDisplayString(item.checkout_time), 1))
          ]),
          break_start_time: _withId(({ item, index }) => [
            _createVNode("pre", null, _toDisplayString(_ctx.displayScheduleBreakStartTime(item, index)), 1)
          ]),
          break_end_time: _withId(({ item, index }) => [
            _createVNode("pre", null, _toDisplayString(_ctx.displayScheduleBreakEndTime(item, index)), 1)
          ]),
          total_break_minutes: _withId(({ item }) => [
            _createVNode("div", null, _toDisplayString(_ctx.convertToDateTime(item.total_break_minutes, 'HH:mm')), 1)
          ]),
          prescribed_outside_of_working_time: _withId(({ item }) => [
            _createVNode("div", null, _toDisplayString(_ctx.convertToDateTime(
                item.prescribed_outside_of_working_time,
                'HH:mm'
              )), 1)
          ]),
          is_remote: _withId(({ item }) => [
            _createVNode("div", null, _toDisplayString(item.is_remote ? _ctx.t('telework') : _ctx.t('office')), 1)
          ]),
          _: 1
        }, 8, ["headers", "data"]),
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, _toDisplayString(_ctx.t('lateTime')), 1),
          _createVNode("div", _hoisted_15, _toDisplayString(_ctx.lateEarlyTime.late_time), 1),
          (!_ctx.applicationFormId)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "mr-24",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.requestLateApplication())),
                disabled: !_ctx.isAddRequestLateTime
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('apply')), 1)
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_16, _toDisplayString(_ctx.t('lateTime')), 1),
          _createVNode("div", _hoisted_17, _toDisplayString(_ctx.lateEarlyTime.early_time), 1),
          (!_ctx.applicationFormId)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                class: "mr-6",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.requestEarlyApplication())),
                disabled: !_ctx.isAddRequestEarlyTime
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('apply')), 1)
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", _hoisted_18, [
        _createVNode("div", _hoisted_19, _toDisplayString(_ctx.t('lateOrEarlyApplication')), 1),
        _hoisted_20,
        _createVNode(_component_Table, {
          class: "overflow-auto text-center",
          headers: _ctx.lateEarlyRequestHeaders,
          data: _ctx.lateEarlyRequestApplication
        }, {
          reason: _withId(({ item, index }) => [
            (!_ctx.applicationFormId)
              ? (_openBlock(), _createBlock(_component_Input, {
                  key: 0,
                  modelValue: item.reason,
                  "onUpdate:modelValue": ($event: any) => (item.reason = $event),
                  required: "",
                  errors: _ctx.errors[`late_or_early_check_times.${index}.reason`],
                  "onUpdate:errors": ($event: any) => (_ctx.errors[`late_or_early_check_times.${index}.reason`] = $event),
                  validated: _ctx.validated,
                  "error-server": 
              _ctx.errorServer[`late_or_early_check_times.${index}.reason`]
            
                }, null, 8, ["modelValue", "onUpdate:modelValue", "errors", "onUpdate:errors", "validated", "error-server"]))
              : (_openBlock(), _createBlock("div", _hoisted_21, _toDisplayString(item.reason), 1))
          ]),
          file: _withId(({ item }) => [
            (!_ctx.applicationFormId)
              ? (_openBlock(), _createBlock(_component_InputFile, {
                  key: 0,
                  modelValue: item.file,
                  "onUpdate:modelValue": ($event: any) => (item.file = $event)
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_22, _toDisplayString(item.file ? item.file.name : _ctx.t('noFileChosen')), 1)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"]))
              : (_openBlock(), _createBlock("div", _hoisted_23, _toDisplayString(item.file_name), 1))
          ]),
          _: 1
        }, 8, ["headers", "data"])
      ]),
      (!_ctx.applicationFormId)
        ? (_openBlock(), _createBlock("div", _hoisted_24, [
            _createVNode("div", null, [
              _createVNode(_component_Button, {
                class: "mb-4",
                onClick: _ctx.submitPostLateEarlyApplication,
                disabled: _ctx.isDisableSubmit
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('register')), 1)
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]),
              _createVNode("span", {
                class: "text-light-blue cursor-pointer hover:opacity-75",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToBack && _ctx.goToBack(...args)))
              }, _toDisplayString(_ctx.t('cancel')), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ReasonUpdateStatusApplication, {
      status: _ctx.lateEarlyApplicationDetail.application_status
    }, null, 8, ["status"]),
    _createVNode(_component_ApplicationApproveFlowDetail, {
      status: _ctx.lateEarlyApplicationDetail.application_status,
      createdAt: _ctx.lateEarlyApplicationDetail.created_at
    }, null, 8, ["status", "createdAt"])
  ], 64))
})